<template>
  <v-row >
    <v-col cols="12" sm="12" class="pa-0">
      <center>
        <span style="font-size: 42px; text-transform: capitalize;"><b>Welcome {{ user.fullname }}!</b></span>
        <br><br>
        <span class="text-ligth" style="font-size: 18px; color: #a0a0a0; font-weight: lighter;">
          Let's plan more intentional 1:1s, Team Meetings, and Development Sessions to build up your people.
        </span>
        <br><br>
        <!-- <v-btn style="text-transform: capitalize; color: #fff;" large @click="direccion('team')"
          color="#000"
          elevation="1"
        >View My Team</v-btn>
        <v-btn class="ml-5" 
          color="#fff"
          elevation="1"
          style="text-transform: none;" large
        >Start a 1:1</v-btn> -->
      </center>  
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "BaseBreadcrumb",
  props: {
    title: String,
    breadcrumbs: Array,
    icon: String,
  },
  data: () => ({}),
  computed:{
      user() {
        return this.$store.getters.getInfoUser;
      },
    },
  methods:{   
        direccion(id){
            this.$router.push(id);
        }
  }
};
</script>
<style lang="scss">
.page-breadcrumb {
  margin: -24px -25px 27px -25px;
}
</style>